export const POPUPS_ADD = "POPUPS_ADD"
export const POPUPS_EDIT = "POPUPS_EDIT"
export const POPUPS_REMOVE = "POPUPS_REMOVE"
export const POPUPS_SET = "POPUPS_SET"
export const POPUPS_STATUS = "POPUPS_STATUS"
